module.exports = __webpack_public_path__ + "static/img/anxun61.a08f9b41.png";